import React from 'react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { strings } from '../../resources/strings';
import { useAuth } from '../../contexts/AuthContext';
import { SeparationType } from '../../enums/SeparationType';
import { ProfileType } from '../../enums/ProfileType';
import { If } from '../../common-components/If/If';
import { useOrdersTable } from './useOrdersTable';
import { TableHead } from './styles';

interface IOrdersTableHeaderProps {
  separationType?: SeparationType;
  selectedAll: boolean;
  selectAllOrder?: () => void;
}

const OrdersTableHeader: React.FC<IOrdersTableHeaderProps> = ({
  separationType,
  selectedAll,
  selectAllOrder
}) => {

  const { session } = useAuth();
  const { getWidthColumns } = useOrdersTable();

  const widthColumn = getWidthColumns(separationType);

  if (separationType === SeparationType.Prescription) return (
    <tr>
      <TableHead width={widthColumn.CheckBox}>
        <Form.Check checked={selectedAll} onChange={() => selectAllOrder ? selectAllOrder() : null} />
      </TableHead>
      <If condition={widthColumn.FulfilledBy !== '0px'} >
        <TableHead width={widthColumn.FulfilledBy}>
          <FontAwesomeIcon icon={faMapMarkerAlt} color='#74777a' size='sm' />
        </TableHead>
      </If>
      <TableHead width={widthColumn.Alerts}></TableHead>
      <TableHead width={widthColumn.OrderNumber}>{strings.OrderNum}</TableHead>
      <TableHead width={widthColumn.PaymentAt}>{strings.Payment}</TableHead>
      <TableHead width={widthColumn.RecipeAt}>{strings.Recipe}</TableHead>
      <If condition={widthColumn.WorkingDays !== '0px'} >
        <TableHead width={widthColumn.WorkingDays}>{strings.WorkingDays}</TableHead>
      </If>
      <If condition={widthColumn.ClientDeadline !== '0px'} >
        <TableHead width={widthColumn.ClientDeadline} textAlign='center'>{strings.ClientDeadline}</TableHead>
      </If>
      <If condition={widthColumn.InternalDeadline !== '0px'} >
        <TableHead width={widthColumn.InternalDeadline} textAlign='center'>{strings.InternalDeadline}</TableHead>
      </If>
      <TableHead width={widthColumn.ClientNameTitle}>{strings.Client}</TableHead>
      <If condition={widthColumn.StateOrderTitle !== '0px'} >
        <TableHead width={widthColumn.StateOrderTitle}>{strings.StateOrder}</TableHead>
      </If>
      <If condition={widthColumn.StateDegreeTitle !== '0px'} >
        <TableHead width={widthColumn.StateDegreeTitle}>{strings.StateDegree}</TableHead>
      </If>
      <If condition={widthColumn.LensMaterialTitle !== '0px' && (session?.user?.profileType == ProfileType.Admin || session?.user?.profileType == ProfileType.Ecommerce)} >
        <TableHead width={widthColumn.LensMaterialTitle}>{strings.Material}</TableHead>
      </If>
      <TableHead width={widthColumn.OptionsTitle} textAlign='right'>{strings.Options}</TableHead>
    </tr>
  );

  return (
    <tr>
      <TableHead width={widthColumn.CheckBox}>
        <Form.Check checked={selectedAll} onChange={() => selectAllOrder ? selectAllOrder() : null} />
      </TableHead>
      <TableHead width={widthColumn.FulfilledBy}>
        <FontAwesomeIcon icon={faMapMarkerAlt} color='#74777a' size='sm' />
      </TableHead>
      <TableHead width={widthColumn.Alerts}></TableHead>
      <TableHead width={widthColumn.OrderNumber}>{strings.OrderNum}</TableHead>
      <TableHead width={widthColumn.PaymentAt}>{strings.Payment}</TableHead>
      <If condition={widthColumn.WorkingDays !== '0px'} >
        <TableHead width={widthColumn.WorkingDays}>{strings.WorkingDays}</TableHead>
      </If>
      <If condition={widthColumn.ClientDeadline !== '0px'} >
        <TableHead width={widthColumn.ClientDeadline}>{strings.ClientDeadline}</TableHead>
      </If>
      <If condition={widthColumn.InternalDeadline !== '0px'} >
        <TableHead width={widthColumn.InternalDeadline}>{strings.InternalDeadline}</TableHead>
      </If>
      <TableHead width={widthColumn.ClientNameTitle}>{strings.ClientName}</TableHead>
      <TableHead width={widthColumn.StateOrderTitle}>{strings.StateOrder}</TableHead>
      <TableHead width={widthColumn.OptionsTitle} textAlign='right'>{strings.Options}</TableHead>
    </tr>
  );
}

export { OrdersTableHeader };